import React from 'react'
import { Container } from '@ui/wrapper'
import BoxImage from '@components/box-image/layout-13'
import { SectionWrapper, StyledText } from './style'

const AusschuesseArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {data.items?.map(
          (item) =>
            item && (
              <BoxImage
                key={item.id}
                title={item.title}
                leftCol={item.images.length ? 6 : 0}
                rightCol={item.images.length ? 6 : 12}
                images={item.images.length ? item.images : null}
                name={item.description}
                path={item.path}
                texts={item.texts}
              >
                {item.texts.map((text, i) => (
                  <React.Fragment key={`${item.id}-text-${i}`}>
                    <StyledText
                      style={{ marginLeft: 0, fontSize: '15px' }}
                      dangerouslySetInnerHTML={{
                        __html: text.content
                      }}
                    />
                  </React.Fragment>
                ))}
              </BoxImage>
            )
        )}
      </Container>
    </SectionWrapper>
  )
}

export default AusschuesseArea
